export default __webpack_public_path__ + "static/sz_en_1-6cf15eddca4fc904735f98ecbbeab493.mp4";